/**
 * Service Dependencies
 */
import http from './HttpService'
import { PORTFOLIO_LIST_URL, PORTFOLIO_CREATE_URL } from '../router/paths'

/**
 * Retrieve the user's portfolios
 *
 * @param  {Object} params
 * @return {Promise}
 */
export const fetchPortfolios = (params = {}) => {
    return http.get(PORTFOLIO_LIST_URL, params)
}

/**
 * Attempt to create a new portfolio object
 *
 * @param  {Object} form
 * @return {Promise}
 */
export const createPortfolio = (form = {}) => {
    return http.post(PORTFOLIO_CREATE_URL, form)
}

/**
 * Fetch the portfolio data for editing
 *
 * @param  {Number} id
 * @return {Promise}
 */
export const fetchEditablePortfolio = (id = null) => {
    return http.get(`portfolios/${id}/?edit=true`)
}

/**
 * Create request to update an existing portfolio
 *
 * @param  {Number} id
 * @param  {Object} payload
 * @return {Promise}
 */
export const updatePortfolio = (id = null, payload) => {
    return http.put(`portfolios/${id}/`, payload)
}



// WEBPACK FOOTER //
// ./src/services/PortfolioService.js